import { SalesConsoleCollapsibleSection } from "@/components/lead/sections/SalesConsoleCollapsibleSection";
import type { ReactNode } from "react";

export function ServiceCollapsibleSection(props: {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  children: ReactNode;
  headerRight?: ReactNode;
}) {
  const { title, subtitle, defaultOpen = false, children, headerRight } = props;
  return (
    <SalesConsoleCollapsibleSection
      title={title}
      subtitle={subtitle}
      defaultOpen={defaultOpen}
      headerRight={headerRight}
    >
      {children}
    </SalesConsoleCollapsibleSection>
  );
}
